export default __webpack_public_path__ + "static/media/gitBW.5ab72bd4.webp";